<template>
  <div class="cell-position">
    <div class="order">{{order}}</div>
    <div class="position">{{position}}</div>
  </div>
  <div class="value">{{value}}</div>
</template>


<script setup>



const props = defineProps({
  position: {
    type: String
  },
  value: {
    type: String
  },
  order: {
    type: [Number, String]
  }
})

</script>

<style>
:host {
  --order-size: 16px;
  margin-top: 8px;
}

:host,
.cell-position {
  display: flex;
  align-items: center;
}

.order {
  width: var(--order-size);
  height: var(--order-size);
  background: #9CA3C1;
  color: #000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.position {
  padding: 0 8px;
}

.value {
  font-weight: bold;
  color: var(--color-text);
}
</style>
